import script from "./TenantManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./TenantManager.vue?vue&type=script&setup=true&lang=ts"

import "./TenantManager.vue?vue&type=style&index=0&id=14c45c98&scoped=true&lang=css"
import "./TenantManager.vue?vue&type=style&index=1&id=14c45c98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14c45c98"]])

export default __exports__